<template>
  <div class="auth-result-container">
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { userStore } from "@/store/userStore";
import loginAPI from "@/api/loginAPI";
import { useRoute } from 'vue-router'; // useRoute 함수 import
const store = userStore();

// 라우트 객체 가져오기
const route = useRoute();

const testData = ref({})

// 컴포넌트 마운트 시 본인인증 데이터 가져오기
onMounted(() => {
  // 모든 쿼리 파라미터 출력
  
  loginAPI.tokenCallback(route.query).then((res) => {
    testData.value = res.data
    
    const safeData = JSON.stringify(res.data);
    window.opener.postMessage({
      type: 'AUTH_LOGIN_SUCCESS',
      data: safeData
    }, window.location.origin); // 보안을 위해 동일 origin으로 제한
    
    // 잠시 후 창 닫기
    setTimeout(() => window.close(), 0);
  });
});
</script>

<style scoped>
.auth-result-container {
  display: none;
  flex-direction: column;
  align-items: center;
  margin: 20px auto;
  max-width: 800px;
  font-family: 'Noto Sans KR', sans-serif;
}

.auth-result-title {
  margin-bottom: 20px;
  text-align: center;
  font-size: 18px;
  line-height: 1.5;
}

.auth-result-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
}

.auth-result-table td {
  border: 1px solid #ccc;
  padding: 10px 15px;
}

.label-cell {
  width: 30%;
  background-color: #f5f5f5;
  font-weight: bold;
}

.info-cell {
  text-align: center;
  background-color: #f8f8f8;
  color: #666;
  line-height: 1.5;
  font-size: 14px;
  padding: 15px;
}

.button-container {
  margin-top: 20px;
}

.close-button {
  width: 150px;
  height: 45px;
  background-color: #3382e9;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.close-button:hover {
  background-color: #2370d4;
}
</style>